/*
  Lazy autoplay videos.

  Background videos on this theme are large (1080p, 10-16MB each). Rendering them
  with a plain `autoplay` attribute makes the browser download the whole file
  during initial page load and keep decoding it forever, even once it has been
  scrolled past. That saturates the connection and pins the main thread, which is
  what makes the site feel laggy on mid-range devices.

  Markup contract (see the ai_gen_block_* files):
    <video data-lazy-video data-lazy-autoplay="true" preload="none" poster="...">
      <source data-src="..." type="video/mp4">
    </video>

  Sources start as `data-src` so nothing is fetched at parse time. This script
  promotes them to `src` and starts playback only once the video is near the
  viewport, and pauses it again when it leaves.
*/
(function () {
  'use strict'

  var ROOT_MARGIN = '200px 0px'

  function loadSources (video) {
    if (video.dataset.lazyVideoLoaded === 'true') return
    video.dataset.lazyVideoLoaded = 'true'

    var sources = video.querySelectorAll('source[data-src]')
    if (!sources.length) return

    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].getAttribute('data-src'))
      sources[i].removeAttribute('data-src')
    }
    video.load()
  }

  function play (video) {
    loadSources(video)
    var attempt = video.play()
    // Autoplay can still be refused (e.g. unmuted video); that is not an error.
    if (attempt && typeof attempt.catch === 'function') {
      attempt.catch(function () {})
    }
  }

  function enter (video) {
    if (video.dataset.lazyAutoplay === 'true') play(video)
    else loadSources(video)
  }

  function leave (video) {
    if (!video.paused) video.pause()
  }

  function observe (videos) {
    // Without IntersectionObserver, fall back to the previous behaviour so the
    // videos still work — just without the loading/CPU savings.
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < videos.length; i++) enter(videos[i])
      return
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) enter(entries[i].target)
        else leave(entries[i].target)
      }
    }, { rootMargin: ROOT_MARGIN, threshold: 0.01 })

    for (var j = 0; j < videos.length; j++) observer.observe(videos[j])
  }

  function init (root) {
    var scope = root || document
    var videos = scope.querySelectorAll('video[data-lazy-video]')
    if (videos.length) observe(videos)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init() })
  } else {
    init()
  }

  // Theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target)
  })
})()
